export default __webpack_public_path__ + "static/media/screen_dropbox_5_2.b9ea815a.png";